/**
 * Fubo Channel Store Data
 * Contains all channel information for the Channel Store template
 */

import { ratePlanCodes } from 'src/constants/ratePlanCode'
import { addParams } from 'src/modules/utils/addParams'

const signupUrl = 'https://www.fubo.tv/signup'

export const fanduelChannel = {
  id: 'fanduel',
  name: 'FanDuel Sports Network',
  slug: 'fanduel-sports-network',
  price: 'As low as $14.99/mo',
  description: 'Stream live games and your local team coverage. Regional restrictions apply.',
  logo: 'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/logos/fanduel.png',
  carouselImage:
    'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/carousel/fanduel.png',
  images: [
    'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/fanduel-sports-network/nba.png',
    'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/fanduel-sports-network/mlb.png',
    'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/fanduel-sports-network/nhl.png',
  ],
  ctaText: 'Start watching for free',
  ctaLink: signupUrl,
  ctaTextShort: 'Try now',
}

export const channels = [
  {
    id: 'paramount-with-showtime',
    name: 'Paramount+ with Showtime',
    slug: 'paramount-with-showtime',
    price: '$10.99/mo',
    description:
      '9 channels of original series, blockbuster movies, boxing and more. Plus the entire SHOWTIME® on-demand library.',
    logo: 'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/logos/showtime.png',
    carouselImage:
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/carousel/showtime.png',
    images: [
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/showtime/billions.png',
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/showtime/dexter.png',
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/showtime/yellowjackets.png',
    ],
    ctaText: 'Get started',
    ctaLink: addParams(signupUrl, `offer=${ratePlanCodes.paramount_with_showtime_mo}`),
    ctaTextShort: 'Get started',
  },
  {
    id: 'fox-nation',
    name: 'FOX Nation',
    slug: 'fox-nation',
    price: '$8.99/mo',
    description:
      'A robust content library of 180+ shows and 1000+ hours of original shows, series and exclusives.',
    logo: 'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/logos/fox-nation.png',
    carouselImage:
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/carousel/fox-nation.png',
    images: [
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/fox-nation/killer-interview.png',
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/fox-nation/murdaugh.png',
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/fox-nation/tomi-lahren.png',
    ],
    ctaText: 'Start watching for free',
    ctaLink: addParams(signupUrl, `offer=${ratePlanCodes.fox_nation_mo}`),
    ctaTextShort: 'Try now',
  },
  {
    id: 'nba-tv',
    name: 'NBA TV',
    slug: 'nba-tv',
    price: '$8.99/mo',
    description:
      "Live NBA games, behind-the-scenes content and exclusive access to the NBA's best players and teams. All season long.",
    logo: 'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/logos/nba-tv.png',
    carouselImage:
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/carousel/nba-tv.png',
    images: [
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/nba-tv/the-association.png',
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/nba-tv/game-time.png',
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/nba-tv/kobe-bryant.png',
    ],
    ctaText: 'Start watching for free',
    ctaLink: addParams(signupUrl, `offer=${ratePlanCodes.nba_tv_mo}`),
    ctaTextShort: 'Try now',
  },
  {
    id: 'dazn1',
    name: 'DAZN1',
    slug: 'dazn1',
    price: '$29.99/mo',
    description:
      'Ringside access to action-packed fights, including fight nights for exclusive X Series crossover boxing, mixed martial arts and more.',
    logo: 'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/logos/dazn1.png',
    carouselImage:
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/carousel/dazn1-v3.png',
    images: [
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/dazn1/canelo.png',
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/dazn1/usyk.png',
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/dazn1/boxing-show.png',
    ],
    ctaText: 'Get started',
    ctaLink: addParams(signupUrl, `offer=${ratePlanCodes.dazn_mo}`),
    ctaTextShort: 'Get started',
  },
  {
    id: 'bein-sports',
    name: 'beIN SPORTS',
    slug: 'bein-sports',
    price: '$5.99/mo',
    description:
      '10 channels of world-class soccer including Ligue 1, SüperLig, Coupe de France, Copa Libertadores, Copa Sudamericana and more.',
    logo: 'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/logos/bein-sports.png',
    carouselImage:
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/carousel/bein-sports.png',
    images: [
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/bein-sports/libertadores.png',
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/bein-sports/ligue-1.png',
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/bein-sports/sudamericana.png',
    ],
    ctaText: 'Get started',
    ctaLink: addParams(signupUrl, `offer=${ratePlanCodes.bein_sports_mo}`),
    ctaTextShort: 'Get started',
  },
  {
    id: 'starz',
    name: 'STARZ',
    slug: 'starz',
    price: '$10.99/mo',
    description:
      'The whole family of STARZ live channels, plus on-demand access to all STARZ shows and movies.',
    logo: 'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/logos/starz.png',
    carouselImage:
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/carousel/starz.png',
    images: [
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/starz/ghost.png',
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/starz/outlander.png',
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/starz/party-down.png',
    ],
    ctaText: 'Get started',
    ctaLink: addParams(signupUrl, `offer=${ratePlanCodes.starz_mo}`),
    ctaTextShort: 'Get started',
  },
  {
    id: 'mgm-plus',
    name: 'MGM+',
    slug: 'mgm-plus',
    price: '$6.99/mo',
    description:
      '3 channels of acclaimed original series and blockbuster movies from MGM, live and on-demand.',
    logo: 'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/logos/mgm-plus.png',
    carouselImage: 'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/carousel/mgm.png',
    images: [
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/mgm/godfather-of-harlem.png',
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/mgm/from.png',
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/mgm/hotel-cocaine.png',
    ],
    ctaText: 'Get started',
    ctaLink: addParams(signupUrl, `offer=${ratePlanCodes.mgm_plus_mo}`),
    ctaTextShort: 'Get started',
  },
  {
    id: 'hallmark-plus',
    name: 'Hallmark+',
    slug: 'hallmark-plus',
    price: '$7.99/mo',
    description:
      'The very best of Hallmark all in one place. Featuring a distinctive blend of all new, exclusive original series, movies and other feel-good content.',
    logo: 'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/logos/hallmark-plus.png',
    carouselImage:
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/carousel/hallmark.png',
    images: [
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/hallmark/when-calls.png',
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/hallmark/the-way-home.png',
      'https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/hallmark/finding-mr-christmas.png',
    ],
    ctaText: 'Start watching for free',
    ctaLink: addParams(signupUrl, `offer=${ratePlanCodes.hallmark_plus_mo}`),
    ctaTextShort: 'Try now',
  },
]

export default channels
